module.exports = __webpack_public_path__ + "static/media/cikrle5.81a184da.jpg";